import { inject, injectable } from 'inversify';

import IdVerificationService from 'src/features/verification/data/service/idVerificationService';
import {
  AuthIdVerificationRequestParams,
  IdVerificationRepositoryInterface,
} from 'src/features/verification/domain/IdVerificationRepositoryInterface';

@injectable()
class IdVerificationRepository implements IdVerificationRepositoryInterface {
  @inject(IdVerificationService)
  private readonly idVerificationService!: IdVerificationService;

  public async getOrCreateSession(params: AuthIdVerificationRequestParams) {
    const response =
      await this.idVerificationService.getOrCreateSession(params);

    return response.data.response_body;
  }

  public async getSessionStatus(params: AuthIdVerificationRequestParams) {
    const response = await this.idVerificationService.getSessionStatus(params);

    return response.data.response_body;
  }
}

export default IdVerificationRepository;
